import { Navigate, useLocation } from 'react-router-dom';
import { APICore } from 'data/api/apiCore';
import { useUser } from 'hooks';

type ProAccountRouteProps = {
    component: React.ComponentType;
    roles?: string;
};

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const ProAccountRoute = ({ component: RouteComponent, roles, ...rest }: ProAccountRouteProps) => {
    let location = useLocation();
    const [user] = useUser();

    const api = new APICore();

    /**
     * not logged in so redirect to login page with the return url
     */
    if (!user || api.isUserAuthenticated() === false) {
        return <Navigate to={'/account/login'} state={{ from: location }} replace />;
    }


    if (!user.store) {
        return <Navigate to={'/profile'} state={{ from: location }} replace />;
    }

    if (!user.store.agorachei_pro && !user.store.franchise) {
        return <Navigate to={'/profile'} state={{ from: location }} replace />;
    }

    // check if route is restricted by role
    if (roles && user && roles.indexOf(user.role ?? '') === -1) {
        // role not authorised so redirect to home page
        return <Navigate to={{ pathname: '/' }} />;
    }

    return <RouteComponent />;
};

export default ProAccountRoute;
